import React from "react";
import {
	MagnifyingGlassIcon
  } from '@heroicons/react/24/outline';

const colourVariants = {
  bg: {
    plum: 'bg-plum-700',
    blue: 'bg-blue-700',
    orange: 'bg-orange-700',
    moon: 'bg-moon-700',
  },
}

export default function SearchButton({setOpen, size, colour}) {

	return (
		<button
			type="button"
			className={`inline-flex cursor-pointer items-center justify-center ${size === 'large' ? 'h-9 shadow-md rounded-md' : 'w-7 h-7 shadow-xs rounded-full mr-5'} text-white ${colour ? colourVariants['bg'][colour] : "bg-moon-700"}`}
			onClick={() => setOpen(true)}
		>
			<span className="sr-only">Search</span>
			{size === 'large' ? 
				<div className="flex flex-inline ml-2 mr-4"><MagnifyingGlassIcon className='w-4 stroke-[3px] mx-2'/> Search</div> : 
				<MagnifyingGlassIcon className='w-4 stroke-[3px]'/>
			}
		</button>
	)
}